import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Link, useNavigate} from "react-router-dom";
import Form, {ButtonItem, ButtonOptions, Item, Label, RequiredRule,} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import {EnvironmentData, forgotPassword, getEnvironments} from '../../../api/auth';
import './ForgotPasswordForm.scss';

export default function ForgotPasswordForm() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [envs, setEnvs] = useState([] as EnvironmentData[]);
    const [showEnvSelector, setShowEnvSelector] = useState(false);
    const formData = useRef({userName: '', portal: ''});

    const companyTypeEditorOptions = {
        stylingMode: 'outlined',
        labelMode: 'floating',
        placeholder: 'Portal',
        dataSource: envs,
        displayExpr: 'name',
        searchEnabled: false,
        valueExpr: 'code',
        showDataBeforeSearchOption: true,
    }

    const onSubmit = useCallback(async (e: any) => {
        e.preventDefault();
        let {userName, portal} = formData.current;
        if (portal === '') {
            setLoading(true);
            const envs = await getEnvironments(userName);
            setLoading(false);
            if (envs.length === 1) {
                portal = envs[0].code;
            } else {
                setEnvs(envs);
                setShowEnvSelector(true);
                return;
            }
        }

        setLoading(true);
        const result = await forgotPassword(userName, portal);
        if (result.isOk) {
            navigate('/forgot-password-question', {state: {userName: userName, question: result.question, environment: portal}});
        } else {
            notify(result.message, 'error', 2000);
        }
        setLoading(false);

    }, [navigate]);

    return (
        <form className={'forgot-password-form'} onSubmit={onSubmit}>
            <Form formData={formData.current} disabled={loading} requiredMark={""}>
                <Item
                    dataField={'userName'}
                    editorType={'dxTextBox'}
                    visible={!showEnvSelector}
                    editorOptions={userNameEditorOptions}
                >
                    <RequiredRule message="User Name is required"/>
                    <Label visible={false}/>
                </Item>
                <Item
                    dataField={'portal'}
                    editorType={'dxSelectBox'}
                    editorOptions={companyTypeEditorOptions}
                    visible={showEnvSelector}
                >
                    <Label visible={false} text={'Portal'}/>
                </Item>
                <ButtonItem>
                    <ButtonOptions
                        elementAttr={submitButtonAttributes}
                        width={'100%'}
                        type={'default'}
                        useSubmitBehavior={true}
                    >
            <span className="dx-button-text">
              {
                  loading
                      ? <LoadIndicator width={'24px'} height={'24px'} visible={true}/>
                      : 'Continue'
              }
            </span>
                    </ButtonOptions>
                </ButtonItem>
                <Item>
                    <div className={'login-link'}>
                        <Link to={'/login'}>Return to Login</Link>
                    </div>
                </Item>
            </Form>
        </form>
    );
}

const userNameEditorOptions = {stylingMode: 'outlined', labelMode: 'floating', placeholder: 'User Name', mode: 'text'};
const submitButtonAttributes = {class: 'submit-button', testid: 'continue', 'data-testid': 'continue'};
